module.exports = __webpack_public_path__ + "fonts/Concrete-2.d221e548.ttf";